import { TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { CustomPagination } from '../common/CustomPagination'
import { StickyTable } from '../common/StickyTable'
import { NOT_APPLICABLE, VENDOR_HEADERS } from '../../constants'
import { TableSkeleton } from '../skeletons/TableSkeleton'
import { CustomTableCell } from '../common/CustomTableCell'
import VendorMenu from '../menus/Vendors'
import { VendorListingProps } from '../../interfaceTypes/props'

const VendorListing = ({ vendors, loading, refetch }: VendorListingProps) => {
  return (
    <>
      <StickyTable pagination={<CustomPagination loading={false} />} height="380px">
        <TableHead>
          <TableRow hover>
            {VENDOR_HEADERS.map((columnName, index) => {
              return (
                <TableCell key={index} component="th" align={'left'}>
                  {columnName}
                </TableCell>
              )
            })}
          </TableRow>
        </TableHead>

        {loading ? (
          <TableSkeleton noOfRows={7} noOfCols={VENDOR_HEADERS.length} />
        ) : (
          <TableBody>
            {vendors?.map(vendor => {
              const { addresses } = vendor || {}
              const fullAddress =
                addresses?.length &&
                `${addresses[0]!.address1 || ''} ${addresses[0]!.address2 || ''} ${addresses[0]!.city || ''} ${
                  addresses[0]!.state || ''
                } ${addresses[0]!.country || ''} ${addresses[0]!.zipCode?.padStart(5, '0') || ''}`

              return (
                <TableRow
                  key={vendor.id}
                  hover
                  sx={vendor.deletedAt ? { opacity: 0.55, bgcolor: 'action.hover' } : undefined}
                >
                  <CustomTableCell value={vendor.vendorId} maxWidth="376px" />
                  <CustomTableCell value={vendor?.name || NOT_APPLICABLE} maxWidth="376px" />

                  <CustomTableCell value={vendor?.phone || NOT_APPLICABLE} />
                  {vendor.addresses && vendor?.addresses?.length > 0 ? (
                    <CustomTableCell value={fullAddress || NOT_APPLICABLE} noWrap={false} />
                  ) : (
                    <CustomTableCell value={NOT_APPLICABLE} />
                  )}
                  <CustomTableCell value={vendor.office?.name || NOT_APPLICABLE} />
                  <CustomTableCell value={!!vendor.required1099} />

                  <TableCell>
                    <VendorMenu vendor={vendor} refetch={refetch} />
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        )}
      </StickyTable>
    </>
  )
}

export default VendorListing
